import { modules } from "../../gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class o1Loading extends cc.Component {

    @property(cc.Label)
    lbLoadText: cc.Label = null;
    @property(cc.Node)
    ndIcon: cc.Node = null;
    @property(cc.Node)
    ndBg: cc.Node = null;

    // LIFE-CYCLE CALLBACKS:

    onLoad() {
        modules().uiControlModule.setGaussianMode(this.ndBg);
    }

    start() {
        let mask = this.ndIcon.getChildByName('mask');
        mask.height = 0;
        cc.tween(mask)
            .then(
                cc.tween()
                    .to(1, {height: 256})
                    .to(0, {height: 0})
            )
            .repeatForever()
            .start();

        // this.schedule(() => {
        //     this.ndIcon.angle -= 22.5;
        // }, 0.1);
    }

    showLoading(text: string) {
        this.lbLoadText.string = text;
    }

    // update (dt) {}
}
